export default __webpack_public_path__ + "static/media/SportKLS_LateralIzq.80ecf90c.webp";